import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";

type Input = { step?: string; name?: string };

function GetStepTestHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const input = toolUse.input as Input | null;
  const done = !!result && !result.isError;
  const { step, name } = input ?? {};

  const text = name
    ? done
      ? `Read step test ${name}`
      : `Reading step test ${name}…`
    : done
      ? `Listed step tests${step ? ` for ${step}` : ""}`
      : `Listing step tests${step ? ` for ${step}` : ""}…`;

  return (
    <ToolStatus
      icon="text-search"
      text={text}
      pending={!done && !interrupted}
    />
  );
}

export const getStepTest: ChatTool = {
  name: "getStepTest",
  Header: GetStepTestHeader,
};
